import { ServiceContainer } from '@tv2-player/service-container/src/serviceContainer';
import { TrackingServices } from '../../plugins/Tracking';
import { AggregateNielsenGateway } from './gateways/AggregateNielsenGateway';
import { NielsenBrowserGateway } from './gateways/NielsenBrowserGateway';
import { NielsenOverseerGateway } from './gateways/NielsenOverseerGateway';
import { NielsenSDK } from './types';
import { INielsenCloudSdk } from './gateways/cloud/NielsenCloudSdk';
import { NielsenCloudGateway } from './gateways/cloud/NielsenCloudGateway';
import { NielsenTrackingMachine } from './NielsenTrackingMachine';
import { UnifiedTrackingPlugin } from '../tracking/UnifiedTrackingPlugin';
import { NielsenOptions } from '../../plugins/types';
import { devFlags } from '../../util/devFlags';

declare global {
  interface Window {
    NOLBUNDLE: any;
  }
}

type BrowserGatewayOptions = {
  gatewayType: 'Browser';
  consentPromise: Promise<boolean>;
  sdk?: NielsenSDK;
};

type CloudSdkGatewayOptions = {
  gatewayType: 'CloudSDK';
  post?: any;
  cloudSdk: INielsenCloudSdk;
};

type GatewayOptions = BrowserGatewayOptions | CloudSdkGatewayOptions;

export function nielsenPluginFactory(nielsenOptions: NielsenOptions & GatewayOptions) {
  return (services: TrackingServices) => {
    const useActive = ServiceContainer.config.get(devFlags.useActiveTrackingNielsen);
    const gateway = new AggregateNielsenGateway([
      nielsenOptions.gatewayType === 'CloudSDK'
        ? new NielsenCloudGateway(nielsenOptions.cloudSdk)
        : new NielsenBrowserGateway(
            nielsenOptions.sdk ?? window.NOLBUNDLE,
            nielsenOptions.appId,
            nielsenOptions.instanceName,
            nielsenOptions.consentPromise
          ),
      new NielsenOverseerGateway(),
    ]);

    const instance = new UnifiedTrackingPlugin(
      () => new NielsenTrackingMachine(gateway, useActive)
    );

    instance.track(services.player, services.media$, services.liveTracking$);
    return instance;
  };
}
